"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckerFactory = void 0;
const depsChecker_1 = require("./depsChecker");
const dotnetChecker_1 = require("./internal/dotnetChecker");
const funcToolChecker_1 = require("./internal/funcToolChecker");
const nodeChecker_1 = require("./internal/nodeChecker");
const vxTestAppChecker_1 = require("./internal/vxTestAppChecker");
class CheckerFactory {
    static createChecker(type, logger, telemetry) {
        switch (type) {
            case depsChecker_1.DepsType.ProjectNode:
                return new nodeChecker_1.ProjectNodeChecker(logger, telemetry);
            case depsChecker_1.DepsType.LtsNode:
                return new nodeChecker_1.LtsNodeChecker(logger, telemetry);
            case depsChecker_1.DepsType.Dotnet:
                return new dotnetChecker_1.DotnetChecker(logger, telemetry);
            case depsChecker_1.DepsType.FuncCoreTools:
                return new funcToolChecker_1.FuncToolChecker(logger, telemetry);
            case depsChecker_1.DepsType.VxTestApp:
                return new vxTestAppChecker_1.VxTestAppChecker(logger, telemetry);
            default:
                throw Error("dependency type is undefined");
        }
    }
}
exports.CheckerFactory = CheckerFactory;
//# sourceMappingURL=checkerFactory.js.map